<template>
    <div class="tableWrapper">
        <div class="tableHolder">
            <table class="table">
                <thead class="header">
                    <tr class="row">
                        <th
                            v-for="(header, index) in headers"
                            :key="index"
                            :class="[!header.align ? 'text-left' : `text-${header.align}`]"
                            class="smallTitle"
                        >
                            {{ header.text }}
                        </th>
                        <th
                            v-if="buttons"
                            class="buttons"
                        >
                        </th>
                    </tr>
                </thead>
                <tbody class="body">
                    <tr
                        v-for="(item, index) in items"
                        :key="index"
                        class="row"
                    >
                        <slot :item="item"></slot>
                    </tr>
                </tbody>
                <tfoot
                    v-if="totalPages && totalPages > 1"
                    class="tableFooter"
                >
                    <tr>
                        <td colspan="999">
                            <Pagination
                                :total="totalPages"
                                :current="currentPage"
                                @changed="(val) => $emit('changePage', val)"
                            />
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>

<script>
import Pagination from './Pagination.vue';

export default {
    components: {
        Pagination,
    },
    props: {
        headers: {
            type: Array,
            required: true,
        },
        items: {
            type: Array,
            required: true,
        },
        buttons: {
            type: Boolean,
            default: true,
        },
        totalPages: {
            type: Number,
            default: null,
        },
        currentPage: {
            type: Number,
            default: null,
        },
    },
};
</script>

<style lang="postcss" scoped>
.tableWrapper {
    position: relative;
}
.table {
    text-align: left;
    width: 100%;
    border-collapse: collapse;
    box-shadow: var(--shadow);
    border-radius: var(--borderRadius);
    background-color: #fff;
}
.row {
    border-bottom: 1px solid var(--borderColor);
}
.body .row:last-child {
    border-bottom: 0;
}
.tableHeading {
    color: var(--grey600);
}
.table >>> td,
.table >>> th {
    padding: 18px 25px;
    @media (--laptop) {
        padding: 16px 10px;
        &:first-child {
            padding-left: 20px;
        }
        &:last-child {
            padding-right: 20px;
        }
    }
}
.table >>> td {
    font-size: 16px;
    @media (--laptop) {
        font-size: 15px;
    }
}
.buttons {
    max-width: 120px;
    min-width: 120px;
}
.table >>> .link:hover {
    color: var(--primary);
}
.tableFooter {
    border-top: 1px solid var(--borderColor);
}
</style>
